// src/supabase.js
import { createClient } from "@supabase/supabase-js";

let supabase = null;

if (typeof window !== "undefined") {
  const supabaseUrl = process.env.GATSBY_SUPABASE_URL;
  const supabaseKey = process.env.GATSBY_SUPABASE_KEY;

  if (!supabaseUrl || !supabaseKey) {
    console.warn("Supabase credentials are missing");
  } else {
    supabase = createClient(supabaseUrl, supabaseKey);
  }
}

export default supabase;
